import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'swb-office-contacts',
  templateUrl: './office-contacts.component.html'
})
export class OfficeContactsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
